import Dexie from 'dexie';
import { useLiveQuery } from 'dexie-react-hooks';

import db, { DEXIE_IS_LOADING } from './db';
import { currentUserId } from './meta';

export function useActivityFeed({ limit = 100, unreadOnly = false, workspaceId = null } = {}) {
  const userId = currentUserId();

  return useLiveQuery(
    () => {
      if (!userId) return [];

      return db.activities
        .where('[recipient_user_id+sort_order]')
        .between([userId, Dexie.minKey], [userId, Dexie.maxKey], false, true)
        .reverse()
        .filter((activity) => {
          if (unreadOnly && activity.read_at != null) return false;
          if (workspaceId && String(activity.workspace_id) !== String(workspaceId)) return false;
          return true;
        })
        .limit(limit)
        .toArray();
    },
    [limit, unreadOnly, userId, workspaceId],
    DEXIE_IS_LOADING,
  );
}

export default useActivityFeed;
